import Api from 'core/services/api'
import { ApplicationConfig } from 'core/services/models/configurations'

const path = '/v1/configurations'

export type TConfigurationsResult = {
  data: ApplicationConfig
}

export const getConfigurations = () => {
  return Api.request<TConfigurationsResult>({
    url: `${path}`,
    method: 'GET',
  })
}
